<app-detail [title]="title" [params]="detailParams"></app-detail>
<app-contacto-detail *ngFor="let item of contactosDetailParams"
                     [params]="item">
</app-contacto-detail>
